import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ShowOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ShowOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M12 3.03C6.59 3.03 2.01 6.78.35 12c1.66 5.22 6.24 8.97 11.65 8.97s9.99-3.75 11.65-8.97C21.99 6.78 17.41 3.03 12 3.03Zm0 15.94c-4.18 0-7.94-2.78-9.53-6.97C4.06 7.81 7.82 5.03 12 5.03s7.94 2.78 9.53 6.97c-1.59 4.2-5.35 6.97-9.53 6.97Z" />
          <path d="M12 7.47C9.5 7.47 7.47 9.5 7.47 12c0 2.5 2.03 4.53 4.53 4.53 2.5 0 4.53-2.03 4.53-4.53 0-2.5-2.03-4.53-4.53-4.53Zm0 7.06c-1.39 0-2.53-1.13-2.53-2.53S10.6 9.47 12 9.47s2.53 1.13 2.53 2.53-1.13 2.53-2.53 2.53Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default ShowOutlined;